import { Component, OnInit ,ViewEncapsulation } from '@angular/core';
import {Router, ActivatedRoute} from "@angular/router";
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators} from '@angular/forms';

import { MatSnackBar, MatSnackBarConfig } from '@angular/material';


import { CustomValidators } from 'ng2-validation';

import { AuthenticationService } from '../../service/authentication.service';
import { Utilisateur } from '../../model/utilisateur.model';
import { UtilisateurService } from '../../service/utilisateur.service';


@Component({
   selector: 'ms-login-session',
   templateUrl:'./login-component.html',
   styleUrls: ['./login-component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {

  public form:FormGroup;
  public email:AbstractControl;
  public password:AbstractControl;

  returnUrl: string;
  userlogin: Utilisateur;
  currentUser : Utilisateur;

  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;




  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private fb:FormBuilder,
    public snackBar: MatSnackBar,
    private utilisateurService: UtilisateurService) {

      this.form = fb.group({
        'email': ['', Validators.compose([Validators.required, CustomValidators.email])],
        'password': ['', Validators.compose([Validators.required])]
      });

      this.email = this.form.controls['email'];
      this.password = this.form.controls['password'];


  }

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem('parklife'));
    this.authenticationService.logout();
    let user = new Utilisateur();
    this.userlogin = user;
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

  }

  //login() {
  //  this.router.navigate(['/reservation/cours']);
 // }
 public onSubmit(user):void {
  if (this.form.valid) {
    //console.log(user);
    const config = new MatSnackBarConfig();
    this.userlogin.login = user.email;
    this.userlogin.password = user.password;

    //console.log(this.userlogin);

    this.utilisateurService.login(this.userlogin).subscribe(res => {
      // console.log(res);

      if(res.idutilisateur == '0') {

        if (res.login == '100') {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Votre login est incorrect.', this.action && this.actionButtonLabel, config);
        }
        if (res.login == '101') {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Votre mot de passe est incorrect.', this.action && this.actionButtonLabel, config);
        }
        if (res.login == '102') {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Votre compte a été desactivé.', this.action && this.actionButtonLabel, config);
        }


      } else {
        sessionStorage.setItem('parklife', JSON.stringify(res));

        if (res.idclient == '0'){
          this.router.navigate(['/administration/activites']);
        } else {
          this.router.navigate(['/reservation']);
        }
      }

    },
    error => {
        console.log (error);
    });


   /* this.authenticationService.login(this.userlogin)
    .subscribe(
      data => {

        console.log(data);
        console.log(data.idclient);
        if (data.idclient == '0'){
          this.router.navigate(['/administration/activites']);
        } else {
          this.router.navigate(['/reservation/cours']);
        }


      },
      error => {
        //this.toastrService.error("Email ou mot de passe incorrect",'Erreur');
        //this.notificationService.printErrorMessage("Email ou mot de passe incorrect");
        //const opt = JSON.parse(JSON.stringify(this.options));
        //const inserted = this.toastrService['error']('Connexion impossible. Login ou mot de passe incorrect.', 'Erreur', opt);


      }); */





  }


 }

}






// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/session/login/login.component.ts